import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IResponse } from 'src/app/shared/models/app';
import { CacheConstant } from '../cache/cache.constant';
import { forkJoin } from 'rxjs';
import { PrincipalService } from './principal.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheResolverService } from '../cache/cache-resolver.service';
import jwt_decode from 'jwt-decode';
import { LOCATION_TOKEN } from 'src/app/shared/modules/shared.module';


@Injectable({
    providedIn: 'root'
})
export class AuthService extends BaseService {
    /*********************Properties*********************/

    /*********************Properties*********************/

    /*********************Constructor*********************/
    constructor(
        protected http: HttpClient,
        private principal: PrincipalService,
        private storage: SessionStorageService,
        private cache : CacheResolverService,
        @Inject(LOCATION_TOKEN) private location: Location
    ) {
        super(http);
    }

    authorize() {
        return new Promise((resolve, reject) => {
            const accounts = this.principal.identity();
            const requests: any = forkJoin(accounts);
            requests.subscribe((response: IResponse[]) => {

                resolve(true);
            });
            resolve(true);
        });


    }

    logOut(logoutMethod:string = 'timeout') {               
        let authToken = this.storage.retrieve(CacheConstant.SessionStorageData.AuthToken);              
        let userId:string = '';
        let userEmail:string = '';
        if(authToken){
            let decoded: any = jwt_decode(authToken);                 
            userId = JSON.parse(JSON.stringify(decoded.user_claims).replace(/\\/g, '').slice(1,-1)).id.toString();                 
            userEmail = JSON.parse(JSON.stringify(decoded.userinfo).replace(/\\/g, '').slice(1,-1)).email;          
        }                         
        this.getEnivronmentForLogout(logoutMethod,userId,userEmail);       
    }

    woRedirect(authToken: any) {
        let accessToken = this.storage.retrieve(CacheConstant.SessionStorageData.AccessToken);
        let idToken = this.storage.retrieve(CacheConstant.SessionStorageData.IdToken);
        let tokenInfo = '?ACCESS_TOKEN=' + accessToken + '&AUTH_TOKEN=' + authToken + '&ID_TOKEN=' + idToken;
    }


    reset() {
        this.storage.clear();
    }

    getEnivronmentForLogout(logoutMethod: any,userId: any,userEmail: any){
        this.principal.auditLogoutDetails(logoutMethod,userId,userEmail).subscribe((response: any)=>{                               
            this.cache.remove(CacheConstant.LocalStorage.RefreshTokenCounter);                             
            this.reset();
            let url = this.apiConfig.login;                       
            this.location.assign(url);
        });
    }

}
